<template>
<div>
    <v-row>
        <v-col v-for="detail in details" :key="detail.id" cols="12" class="">
            <v-card flat align="center" class="card dt-border">
                <v-row align="center" >
                    <v-col md="8" class="card__column">
                        <img
                        class="card__column__img"
                        width="40"
                        height="40"
                        :src="detail.icon"
                        />
                        <p class="black--text mb-0 table-link" @click="openGiftcard(detail)">{{detail.name}}</p>
                    </v-col>
                    <v-col md="2">
                        <v-icon v-if="detail.status == active" color="green">
                            mdi-checkbox-marked-circle
                        </v-icon>
                        <v-icon v-if="detail.status == inactive" color="red">
                            mdi-close-circle
                        </v-icon>
                    </v-col>
                    <v-col md="2">
                        <v-menu :close-on-content-click="true" bottom right>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" icon>
                                    <v-icon>
                                        mdi-dots-vertical
                                    </v-icon>
                                </v-btn>
                            </template>

                            <v-list>
                                <v-list-item link>
                                    <v-list-item-title v-if="detail.status == active" color="red" @click="editStatus(detail,inactive)" >Disable</v-list-item-title>
                                    <v-list-item-title v-if="detail.status == inactive" @click="editStatus(detail,active)" >Enable</v-list-item-title>
                                </v-list-item>
                                <v-list-item link>
                                    <v-list-item-title>
                                        <editstore-modal @closeModal = "closeModal" :details = "detail" />
                                    </v-list-item-title>
                                </v-list-item>
                               
                            </v-list>
                        </v-menu> 
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
    </div>
</template>

<script>
// =========== IMPORT COMPONENTS =============
import EditstoreModal from './edit-store-modal.vue'
// import DtunesLoader from "@/components/dtunes-loader.vue"

// ============= IMPORT SERVICES =============
import { StoresService } from "@/services";
import { StatusType } from "@/enums";

export default {
  props: {
    details: {
      type: Array,
    },
  },
  components:{
    EditstoreModal
},
  data: () => ({
      active : StatusType.ACTIVE,
      inactive : StatusType.INACTIVE,
      loading: false,
  }),
  methods: {
      async openGiftcard(detail){
          this.$store.dispatch('setCurrentGiftcard',detail.name);
          this.$router.push({
              path : this.$route.path+'/'+detail.id
          })
      },
      async editStatus(index, status){
          this.loading = true;
          try {
              const data = await StoresService.editStores({
                id:index.id,
                status:status
            });
            this.loading = false;
            if(status == this.active){
                this.$store.dispatch('toast', {
                message: `${index.name} Store has been activated`,
                variant: 'success'
                })
            }
            if(status == this.inactive){
                this.$store.dispatch('toast', {
                message: `${index.name} Store has been deactivated`,
                variant: 'success'
                })
            }
            console.log(data);
            this.$emit('reload');
          } catch (error) {
              this.loading = false
              console.log(error);
          }
      },
      async closeModal(){
          this.$emit('reload');
      },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
@import './styles.scss'

</style>
